export const styles = {
  card: {
    borderRadius: 20,
    height: "auto",
    width: "auto",
    padding: 10,
  },
  cardDetail: {
    display: "flex",
    alignItems: "center",
  },
  title: {
    margin: 0,
  },
};
